import { AlertTriangle, Home } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@easyflow/ui-frontend/components/ui/button';

/**
 * Neutral error state for a missing tenant or a tenant outside W3 Suite.
 * It intentionally does not disclose whether the requested slug exists in
 * another product.
 */
export default function TenantNotFound() {
  const navigate = useNavigate();

  return (
    <main className="flex min-h-screen items-center justify-center bg-muted px-4">
      <section
        aria-labelledby="tenant-not-found-title"
        className="w-full max-w-md rounded-3xl border border-border bg-background p-8 text-center shadow-xl"
      >
        <AlertTriangle className="mx-auto mb-5 h-16 w-16 text-destructive" aria-hidden="true" />
        <p className="mb-2 text-sm font-semibold uppercase tracking-[0.2em] text-muted-foreground">
          Errore 404
        </p>
        <h1 id="tenant-not-found-title" className="mb-3 text-3xl font-bold text-foreground">
          Pagina non trovata
        </h1>
        <p className="mb-7 text-muted-foreground">
          L&apos;indirizzo richiesto non è disponibile su W3 Suite.
        </p>
        <Button className="w-full" size="lg" onClick={() => navigate('/', { replace: true })}>
          <Home className="mr-2 h-4 w-4" />
          Vai alla home
        </Button>
      </section>
    </main>
  );
}